import { render, staticRenderFns } from "./ui-product-counter.vue?vue&type=template&id=708fa7f8&scoped=true&"
import script from "./ui-product-counter.vue?vue&type=script&lang=js&"
export * from "./ui-product-counter.vue?vue&type=script&lang=js&"
import style0 from "./ui-product-counter.vue?vue&type=style&index=0&id=708fa7f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708fa7f8",
  null
  
)

export default component.exports